@if ((shouldShowFohSelection$ | async) && (hasFundsOnHold$ | async)) {
  <div class="foh-selection">
    <div class="foh-toggle-button-wrapper">
      <button class="foh-toggle-button" [class.checked]="isFohEnabled" (click)="onFohToggle()">
        <rkt-icon [name]="isFohEnabled ? 'checkbox-on' : 'checkbox-off'"></rkt-icon>
        Use funds on hold
      </button>
    </div>

    <div class="foh-content" [hidden]="!isFohEnabled">
      @if (selectedFoh$ | async; as foh) {
        <div class="foh-selected">
          <div class="foh-selected-info">
            <div class="foh-selected-row">
              <span class="foh-label">Amount:</span>
              <span class="foh-value">${{ foh.amount }}</span>
            </div>
            @if (foh.memo) {
              <div class="foh-selected-row">
                <span class="foh-label">Memo:</span>
                <span class="foh-value">{{ foh.memo }}</span>
              </div>
            }
            <div class="foh-selected-row">
              <span class="foh-label">Expiry:</span>
              <span class="foh-value">{{ foh.expiry | date: 'MM/dd/yy HH:mm' }}</span>
            </div>
          </div>
          <div class="foh-actions">
            <button class="foh-action-btn" (click)="onSelectFohClick()" title="Change">
              <rkt-icon name="edit"></rkt-icon>
            </button>
            <button class="foh-action-btn foh-action-btn--delete" (click)="onClearFoh()" title="Remove">
              <rkt-icon name="trash"></rkt-icon>
            </button>
          </div>
        </div>
        @if (isFohAmountExceeded$ | async) {
          <div class="foh-error">Transaction amount exceeds the selected Fund on Hold amount.</div>
        }
      } @else {
        <button class="foh-empty-state-button" (click)="onSelectFohClick()">
          <div class="foh-empty-state-icon"><rkt-icon name="plus"></rkt-icon></div>
        </button>
      }
    </div>
  </div>
}
